// extracted by mini-css-extract-plugin
module.exports = {"container":"basicpages_container__p247s","title":"basicpages_title__Xxn_s","portabletext":"basicpages_portabletext__wGu2v","backBtnContainer":"basicpages_backBtnContainer__xl17P"};